import { render, staticRenderFns } from "./myCourse.vue?vue&type=template&id=64691dd6&scoped=true"
import script from "./myCourse.vue?vue&type=script&lang=js"
export * from "./myCourse.vue?vue&type=script&lang=js"
import style0 from "./myCourse.vue?vue&type=style&index=0&id=64691dd6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64691dd6",
  null
  
)

export default component.exports